import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';

import { SplashScreen } from 'src/components/loading-screen';

const RegisterPage = lazy(() => import('src/modules/auth/register/register'));
const RegisterOtpPage = lazy(() => import('src/modules/auth/register/register-otp'));
const LoginPage = lazy(() => import('src/modules/auth/login/login'));

const authJwt = {
  element: (
    <GuestGuard>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </GuestGuard>
  ),
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      path: 'register',
      element: <RegisterPage />,
    },
    {
      path: 'register/otp',
      element: <RegisterOtpPage />,
    },
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
